import { Alumni, AlumniExtended } from "iasma-datatypes";
import ViewMerge from "./ViewMerge";

export function ViewMergeTest() {
	let main: AlumniExtended = {
		Id: 3301,
		Name: "Adek Rendra Muchtar PhD",
		Graduation: 1993,
		Gender: undefined,
		Religion: undefined,
		NIS: 9774,
		Classes: "I-2,II-FIS-2,III-FIS-2",
		Status: undefined,
		Alias: undefined,
		Title: undefined,
		BirthDate: "1975-01-17",
		DOD: undefined,
		Phones: "08159370075",
		Privacies: "0000000000",
		ExtraData: {},
		Addresses: [
			{
				Id: 2807,
				Kind: "rumah",
				Street: "Jl. Setiabudi Jakarta",
				Village: "",
				District: "",
				City: "Jakarta Selatan",
				State: "DKI Jakarta",
				Country: "Indonesia",
				ZipCode: ""
			}
		],
		Businesses: [
			{
				Id: 1560,
				Category: "",
				Specialty: "",
				Company: "",
				Title: "",
				Periode: "",
				IsActive: false,
				Description: "Dirjen Anggaran, Departemen Keuangan"
			},
			{
				Id: 1613,
				Category: "",
				Specialty: "",
				Company: "",
				Title: "",
				Periode: "",
				IsActive: false,
				Description: "Dirjen Anggaran, Departemen Keuangan"
			}
		],
		Relations: [],
		Academics: [],
		WebUsers: [],
		Links: []
	}
	let other: AlumniExtended = {
		Id: 25640,
		Name: "ADEK RENDRA MUCHTAR",
		Graduation: 1993,
		Gender: "M" as Alumni["Gender"],
		Religion: undefined,
		NIS: undefined,
		Classes: "3Fisik2",
		Status: undefined,
		Alias: "Adek",
		Title: "PhD",
		BirthDate: "1975-01-17",
		DOD: undefined,
		Phones: "081959927464",
		Privacies: "0000000000",
		ExtraData: {
			History: {
				"2023-07-26 14:17:48": {
					Action: "Create",
					By: "Google Sign-In",
					ActivityId: "register",
					OriginalId: 0
				},
				"2023-07-26 14:22:16": {
					Action: "Update",
					By: "Adek Muchtar",
					Data: "{\"Alias\":\"Adek\",\"BirthDate\":\"1975-01-17\",\"Classes\":\"3Fisik2\",\"Addresses\":\"Apartemen Oasis Mitra Sarana Tower B1106\\nJalan Senen RayaNo 135-137 Senen\\nJakarta Pusat 10410\",\"Phones\":\"081959927464\",\"Business\:\"PNS Kemenkeu\",\"Title\:\"PhD\"}"
				}
			}
		},
		Addresses: [
			{
				Id: 10476,
				Kind: "rumah",
				Street: "Apartemen Oasis Mitra Sarana Tower B1106\nJalan Senen RayaNo 135-137 Senen\nJakarta Pusat 10410",
				Village: "",
				District: "",
				City: "",
				State: "",
				Country: "",
				ZipCode: ""
			}
		],
		Businesses: [
			{
				Id: 6590,
				Category: "",
				Specialty: "",
				Company: "",
				Title: "",
				Periode: "",
				IsActive: false,
				Description: "PNS Kemenkeu"
			},
			{
				Id: 6783,
				Category: "",
				Specialty: "",
				Company: "",
				Title: "",
				Periode: "",
				IsActive: false,
				Description: "PNS Kemenkeu"
			}
		],
		Relations: [],
		Academics: [],
		WebUsers: [
			{
				Id: 2094,
				Name: "Adek Muchtar",
				Email: "adekrendra@gmail.com"
			}
		],
		Links: []
	}

	return <ViewMerge main={main} other={other} />
}